// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"nect_qrcode__2Q_6t"};